/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Picker_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No members found" |
*
* @param {User_Picker_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_picker_no_results = /** @type {((inputs?: User_Picker_No_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Picker_No_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun membre trouvé")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron miembros")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum membro encontrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun membro trovato")
	return /** @type {LocalizedString} */ ("No members found")
});